export default "__VITE_ASSET__CSDAjR5Z__"